import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type CreateProductAttributeMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateCoreProductAttributeInput;
}>;

export type CreateProductAttributeMutationResult = { __typename?: 'Mutation' } & {
  createCoreProductAttribute: { __typename?: 'CreateCoreProductAttributePayload' } & {
    coreProductAttribute?: GraphQLTypes.Maybe<
      { __typename?: 'CoreProductAttribute' } & Pick<GraphQLTypes.CoreProductAttribute, 'id' | 'name' | 'type'>
    >;
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const CreateProductAttributeDocument = /*#__PURE__*/ gql`
  mutation createProductAttribute($input: CreateCoreProductAttributeInput!) {
    createCoreProductAttribute(input: $input) {
      coreProductAttribute {
        id
        name
        type
      }
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useCreateProductAttributeMutation__
 *
 * To run a mutation, you first call `useCreateProductAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductAttributeMutation, { data, loading, error }] = useCreateProductAttributeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductAttributeMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateProductAttributeMutationResult, CreateProductAttributeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CreateProductAttributeMutationResult, CreateProductAttributeMutationVariables>(
    CreateProductAttributeDocument,
    options
  );
}
export type CreateProductAttributeMutationHookResult = ReturnType<typeof useCreateProductAttributeMutation>;
